import { UsuarioService } from './../../usuarios/services/usuario.service';
import { ClienteVM } from './../../../_entities/clientes/ClienteVM';
import { AppState } from './../../../core/reducers/index';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { debounceTime, finalize, takeUntil, tap } from 'rxjs/operators';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, Subscription } from 'rxjs';
import { ConfirmPasswordValidator } from '../register/confirm-password.validator';
import { AuthService } from './../../auth/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'kt-registro-pasajero',
  templateUrl: './registro-pasajero.component.html',
  styleUrls: ['./registro-pasajero.component.scss']
})
export class RegistroPasajeroComponent implements OnInit {
	public usuarioForm: FormGroup;
	public clientesRegistros: ClienteVM[];
	public idUsuarioMod: string;
	public param: Subscription;
	public loading: boolean = false;
	public titulo: string = 'Agregar Usuario';
	public permisosActuales: string[] = [];
	public mensajes = {
		nombre: '',
		apellidoPaterno: '',
		apellidoMaterno: '',
		correo: '',
		password: '',
		confirmPassword: '',
		permisos: ''
	};
	public listaTiposUsuario=[{id:'156', nombre:'Pasajero'},{id:'158',nombre:'Conductor'}]
	public tiempoEspera: number = 1000;

	constructor(
		private auth: AuthService,
		private fb: FormBuilder,
		private route: ActivatedRoute,
		private authService: AuthService,
		private usuarioService: UsuarioService,
		private toastr: ToastrService,
		private router: Router,
	) { }

	ngOnInit() {
		this.initForm();
	
	}


	initForm() {
		this.usuarioForm = this.fb.group({
			nombre: ['', [Validators.required, Validators.maxLength(200)]],
			apellidoPaterno: ['', [Validators.maxLength(200)]],
			apellidoMaterno: ['', [Validators.maxLength(200)]],
			correo: ['', [Validators.required, Validators.email]],
			passwordGroup: this.fb.group({
				password: ['',
					Validators.compose([Validators.required, Validators.minLength(8),
					Validators.maxLength(16),
					Validators.pattern('^(?=\\w*\\d)(?=\\w*[A-Z])(?=\\w*[a-z])\\S{8,16}$')])],
				confirmPassword: ['', Validators.compose([Validators.required, Validators.minLength(8),
					Validators.maxLength(16),
					Validators.pattern('^(?=\\w*\\d)(?=\\w*[A-Z])(?=\\w*[a-z])\\S{8,16}$')])]
			}, { validators: passwordMatcher }),
			permisos: [['']],
			idCliente: [4],
   	   fechaNacimiento:[]
		});
		this.initFormValidation();
	}

	initFormValidation() {
		const nombreControl = this.usuarioForm.get('nombre');
		const apellidoPaternoControl = this.usuarioForm.get('apellidoPaterno');
		const apellidoMaternoControl = this.usuarioForm.get('apellidoMaterno');
		const correoControl = this.usuarioForm.get('correo');
		const passwordControl = this.usuarioForm.get('passwordGroup.password');
		const confirmPasswordControl = this.usuarioForm.get('passwordGroup.confirmPassword');
		const permisosControl = this.usuarioForm.get('permisos');
		const idClienteControl = this.usuarioForm.get('idCliente');
		nombreControl.valueChanges.pipe(
			debounceTime(this.tiempoEspera)
		).subscribe(
			value => this.setMessage(nombreControl, 'nombre', 'Nombre')
		);
		apellidoPaternoControl.valueChanges.pipe(
			debounceTime(this.tiempoEspera)
		).subscribe(
			value => this.setMessage(apellidoPaternoControl, 'apellidoPaterno', 'Apellido Paterno')
		);
		apellidoMaternoControl.valueChanges.pipe(
			debounceTime(this.tiempoEspera)
		).subscribe(
			value => this.setMessage(apellidoMaternoControl, 'apellidoMaterno', 'Apellido Materno')
		);
		if (!this.idUsuarioMod) {
			correoControl.valueChanges.pipe(
				debounceTime(this.tiempoEspera)
			).subscribe(
				value => this.setMessage(correoControl, 'correo', 'Correo')
			);
			passwordControl.valueChanges.pipe(
				debounceTime(this.tiempoEspera)
			).subscribe(
				value => this.setMessage(passwordControl, 'password', 'Contraseña')
			);
			confirmPasswordControl.valueChanges.pipe(
				debounceTime(this.tiempoEspera)
			).subscribe(
				value => this.setMessage(confirmPasswordControl, 'confirmPassword', 'Confirmación Contraseña')
			);
		}
		permisosControl.valueChanges.pipe(
			debounceTime(this.tiempoEspera)
		).subscribe(
			value => this.setMessage(permisosControl, 'permisos', 'Permisos')
		);
		if (this.idUsuarioMod) {
			idClienteControl.valueChanges.pipe(
				debounceTime(this.tiempoEspera)
			).subscribe(
				value => this.setMessage(idClienteControl, 'idCliente', 'Cliente')
			);
		}
	}

	setMessage(c: AbstractControl, campo: string, campoVisual: string): void {
		this.mensajes[campo] = '';
		if ((c.touched || c.dirty) && c.errors) {
			this.mensajes[campo] = Object.keys(c.errors).map(
				key => this.generateMessage(c, key, campoVisual)
			).join(' ');
		}
	}

	generateMessage(c: AbstractControl, key: string, campoVisual: string): string {
		switch (key) {
			case 'required':
				return `El campo ${campoVisual} es requerido`;
			case 'match':
				return 'Las contraseñas no coinciden'
			case 'email':
				return 'Ingrese un correo válido';
			case 'minlength':
				return `El campo ${campoVisual} tiene una longitud mínima de ${c.errors[key].requiredLength} caracteres`;
			case 'maxlength':
				return `El campo ${campoVisual} tiene una longitud máxima de ${c.errors[key].requiredLength} caracteres`;
			case 'pattern':
				return 'La contraseña debe ser de 6 o más caracteres y contener mayúsculas y minúsculas, por lo menos un número y un símbolo'
			default:
				return `El campo ${campoVisual} es inválido`;
		}
	}

	onCancel() {
		this.router.navigateByUrl('/login');
	}

	onSubmit() {
		this.loading = true;
	  this.registrarUsuario()
	}
	public permiso;
	registrarUsuario() {
		this.permisosActuales.push(this.usuarioForm.get('permisos').value)
	   this.usuarioForm.patchValue({
		   permisos:this.permisosActuales
	   })
	   var usuario = { ...this.usuarioForm.value };

		usuario = { ...usuario, ...this.usuarioForm.get('passwordGroup').value }
		this.authService.registrarPasajero(usuario).subscribe(success => {
			this.usuarioForm.reset();
			this.toastr.success('Usuario registrado correctamente', 'Operación Exitosa');
      this.loading = false;
		this.router.navigateByUrl('/login');
		},
			err => {
				this.toastr.error('Ocurrió un error al intentar registrar el usuario: ' + err, 'Error en la Operación');
				this.loading = false;
				this.usuarioForm.reset();
			},
			() => this.onSubmitComplete());

	}



	onSubmitComplete() {
		this.router.navigateByUrl('/login');
		this.loading = false;
	}



	checkedBox(permiso) {
		let checked = false;
		let permisos: string[] = this.usuarioForm.get('permisos').value;

		if (permisos.includes(permiso.nombre)) {
			checked = true;
		}
		return checked;
	}


	/**Pasar el valor del mat-slide de boolean a number */
	public checado: boolean = false;
	onChange(value, permiso) {
		if (value.checked === true) {
			this.permisosActuales.push(permiso);
		} else {
			this.permisosActuales.splice(this.permisosActuales.findIndex(item => item === permiso), 1)
		}

		this.usuarioForm.patchValue({
			permisos: this.permisosActuales
		})
	}

}

function passwordMatcher(c: AbstractControl): { [key: string]: boolean } | null {
	const passwordControl = c.get('password');
	const confirmPasswordControl = c.get('confirmPassword');

	if (passwordControl.pristine || confirmPasswordControl.pristine) {
		confirmPasswordControl.setErrors(null);
		return null;
	}

	if (passwordControl.value === confirmPasswordControl.value) {
		confirmPasswordControl.setErrors(null);
		return null;
	}

	confirmPasswordControl.setErrors({ 'match': true });

	return { 'match': true };

}
